// openaiClient.ts
import OpenAI from "openai";

// Initialize the OpenAI client with the API key.
export const openaiClient = new OpenAI({
    apiKey: "openai-api-key",
    dangerouslyAllowBrowser: true,
});
